import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export function MaintenancePage() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>En mantenimiento</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            La plataforma está en mantenimiento. Vuelve más tarde.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
